
import moment from 'moment'
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator'
import { integerMask, currencyMask, percentageMask } from '@/models/interface/Masks'
import User from '@/models/User'
import CheckboxInput from '@/components/CheckboxInput/index.vue'
import SelectPicker from '@/components/SelectPicker/SelectPicker.vue'
import UserPicker from '@/components/UserPicker/UserPicker.vue'
import IconAction from '@/components/IconAction/IconAction.vue'
import DatePicker from '@/components/DatePicker/DatePicker.vue'
import FormInput from '@/components/FormInput/FormInput.vue'
import ManageActionsBtns from './ManageActionsBtns.vue'

@Component({
  components: {
    ManageActionsBtns,
    CheckboxInput,
    SelectPicker,
    UserPicker,
    IconAction,
    DatePicker,
    FormInput,
  },
})
export default class DynamicInputs extends Vue {
  @Prop() public value!: any

  @Prop() public type!: string

  @Prop() public section!: any

  public loading: boolean = false

  public editing: any = []

  public loaded_data: any = {}

  public get maskList() {
    return { integerMask, currencyMask, percentageMask }
  }

  public clearName(name: any) {
    return name.replaceAll('_', ' ')
  }

  public capitalize(name: any) {
    // @ts-ignore
    return this.$options.filters.capitalize(this.clearName(name))
  }

  public generateId(name: any) {
    return name.replaceAll('_', '-')
  }

  public checkDataToFormat(section: any) {
    if (section.input_type === 'user_picker') {
      if (!this.loaded_data[section.id]) {
        this.loaded_data[section.id] = {
          value: section.key_value,
          name: 'loading...',
          param_id: section.id,
        }
        setTimeout(() => {
          this.searchUser(section.key_value, section.id)
        }, 1000)
      }
      if (this.loaded_data[section.id] && !this.loaded_data[section.id].name.includes('loading')) {
        if (this.loaded_data[section.id].value !== section.key_value) {
          delete this.loaded_data[section.id]
          this.checkDataToFormat(section)
        }
      }
      return this.loaded_data[section.id].name
    }

    return this.formatByValueType(section)
  }

  public formatByValueType(section: any) {
    if (section.value_type === 'percent') {
      return `${section.key_value}%`
    }

    if (section.value_type === 'boolean') {
      return section.key_value ? 'Yes' : 'No'
    }

    if (section.value_type === 'date') {
      return moment(section.key_value).format('MM/DD/YYYY')
    }
    return section.key_value
  }

  public checkMasks(section: any) {
    if (section.value_type === 'currency') {
      return this.maskList.currencyMask
    }
    if (section.value_type === 'percent') {
      return this.maskList.percentageMask
    }
  }

  public removeSelection(section: any, force: boolean = false, event: any = null) {
    if (
      this.loaded_data[section.id]
      && event
      && this.loaded_data[section.id].value !== event.value
    ) {
      // When this condition is true, it means that the user has changed the value of a loaded data
      this.loaded_data[section.id] = {
        name: event.name,
        value: event.value,
      }
      // @ts-ignore
      if (this.$refs[`load-${section.id}`].length) {
        // @ts-ignore
        this.$refs[`load-${section.id}`][0].innerText = event.name
      }
    }
    const exec = () => (this.editing = this.editing.filter((item: any) => item !== section.key))
    if (force) exec()
    else {
      setTimeout(() => {
        exec()
      }, 500)
    }
  }

  public searchUser(id: any, param_id: any) {
    this.loading = true
    User.searchOptions({
      value: id,
    }).then(response => {
      this.loaded_data[param_id].name = response[0]?.name || '-'
      // @ts-ignore
      if (this.$refs[`load-${param_id}`].length) {
        // @ts-ignore
        this.$refs[`load-${param_id}`][0].innerText = response[0]?.name || '-'
      }
      this.loading = false
    })
  }
}
